module.exports = __webpack_public_path__ + "img/woman2.25ccd912.png";